module.exports = __webpack_public_path__ + "img/noun-pricing-1127520.bab716df.svg";